export { default as SupportedMerchantsList } from './SupportedMerchantsList/SupportedMerchantsList';
